/**
 * Main Entry Point
 * Initializes React app with all context providers and global styles
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider, AuthProvider } from '@/context';
import AppRouter from '@/router/AppRouter';
import LiveChatWidget from '@/components/common/LiveChatWidget';
import { installBackendFetchRewrite } from '@/utils/runtimeUrls';

// Import global styles
import './styles/index.css';
import './styles/focus-visible.css';

const root = document.getElementById('root');
const queryClient = new QueryClient();

installBackendFetchRewrite();

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppProvider
          // Network configuration
          networkStorageKey="MangoGrid-studio-network"
          initialNodes={[]}
          initialConnections={[]}

          // Pyodide configuration
          autoInitializePyodide={false}
          maxConsoleEntries={100}
        >
          <AppRouter />
          <LiveChatWidget />
        </AppProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
